import api from './api'

// --- Authenticated user ---
export async function listPosts(page = 1) {
  const res = await api.get('/whatsnew/posts', { params: { page } })
  return res.data
}

export async function getPostBySlug(slug) {
  const res = await api.get(`/whatsnew/posts/${slug}`)
  return res.data
}

export async function getLatestUnseen() {
  const res = await api.get('/whatsnew/latest-unseen')
  return res.data
}

export async function getUnseenCount() {
  const res = await api.get('/whatsnew/unseen-count')
  return res.data
}

export async function markSeen(postId) {
  const res = await api.post(`/whatsnew/posts/${postId}/seen`)
  return res.data
}

// --- Admin (whatsnew:manage) ---
export async function adminListPosts() {
  const res = await api.get('/whatsnew/admin/posts')
  return res.data
}

export async function getAdminPost(id) {
  const res = await api.get('/whatsnew/admin/posts/' + id)
  return res.data
}

export async function createPost(payload) {
  const res = await api.post('/whatsnew/posts', payload)
  return res.data
}

export async function updatePost(id, payload) {
  const res = await api.put(`/whatsnew/posts/${id}`, payload)
  return res.data
}

export async function publishPost(id, published) {
  const res = await api.patch(`/whatsnew/posts/${id}/publish`, {
    status: published ? 'published' : 'draft',
  })
  return res.data
}

export async function deletePost(id) {
  const res = await api.delete(`/whatsnew/posts/${id}`)
  return res.data
}

export async function getImageUploadUrl(filename, mime) {
  const res = await api.post('/whatsnew/upload-image', { filename, mime })
  return res.data // { put_url, s3_key, public_url }
}

export async function uploadImageFile(file) {
  const { put_url, public_url } = await getImageUploadUrl(file.name, file.type)
  const res = await fetch(put_url, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
  })
  if (!res.ok) throw new Error(`Échec de l'upload S3 (${res.status})`)
  return public_url
}

export async function sendCampaign(postId) {
  const res = await api.post(`/whatsnew/posts/${postId}/send`)
  return res.data
}

export async function getCampaign(campaignId) {
  const res = await api.get(`/whatsnew/campaigns/${campaignId}`)
  return res.data
}
